"use strict";
/**
 * NEAR RPC API request types and responses
 * @module
 */

var _createClass = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/classCallCheck.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransactionLastResult = exports.Provider = exports.IdType = exports.FinalExecutionStatusBasic = exports.ExecutionStatusBasic = void 0;
var ExecutionStatusBasic;

(function (ExecutionStatusBasic) {
  ExecutionStatusBasic["Unknown"] = "Unknown";
  ExecutionStatusBasic["Pending"] = "Pending";
  ExecutionStatusBasic["Failure"] = "Failure";
})(ExecutionStatusBasic = exports.ExecutionStatusBasic || (exports.ExecutionStatusBasic = {}));

var FinalExecutionStatusBasic;

(function (FinalExecutionStatusBasic) {
  FinalExecutionStatusBasic["NotStarted"] = "NotStarted";
  FinalExecutionStatusBasic["Started"] = "Started";
  FinalExecutionStatusBasic["Failure"] = "Failure";
})(FinalExecutionStatusBasic = exports.FinalExecutionStatusBasic || (exports.FinalExecutionStatusBasic = {}));

var IdType;

(function (IdType) {
  IdType["Transaction"] = "transaction";
  IdType["Receipt"] = "receipt";
})(IdType = exports.IdType || (exports.IdType = {}));
/** @hidden */


var Provider = /*#__PURE__*/_createClass(function Provider() {
  _classCallCheck(this, Provider);
});

exports.Provider = Provider;
/** @hidden */

function getTransactionLastResult(txResult) {
  if (typeof txResult.status === 'object' && typeof txResult.status.SuccessValue === 'string') {
    var value = Buffer.from(txResult.status.SuccessValue, 'base64').toString();

    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  return null;
}

exports.getTransactionLastResult = getTransactionLastResult;